<template>
  <div class="withdrawal">
    <!-- 查询条件 -->
    <vab-query-form>
      <vab-query-form-left-panel :span="18">
        <el-form inline>
          <el-form-item label="推荐人姓名">
            <el-input v-model="queryParams.likeName" clearable placeholder="请输入推荐人姓名" @change="query(1)" />
          </el-form-item>
          <el-form-item label="推荐人手机号">
            <el-input v-model="queryParams.phone" clearable placeholder="请输入推荐人手机号" @change="query(1)" />
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="queryParams.status" clearable placeholder="请选择状态" @change="query(1)">
              <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-form>
      </vab-query-form-left-panel>
      <vab-query-form-right-panel :span="6">
        <el-button icon="search" type="primary" @click="query()">查询</el-button>
        <el-button icon="refresh" type="warning" @click="reset">重置</el-button>
      </vab-query-form-right-panel>
    </vab-query-form>

    <!-- 表格 -->
    <el-table v-loading="loading" border :data="tableData" :table-layout="'auto'">
      <el-table-column label="推荐人姓名" prop="recommenderName" />
      <el-table-column label="推荐人手机号" prop="recommenderPhone" />
      <el-table-column label="被推荐人" prop="userNames" />
      <el-table-column label="提现金额">
        <template #default="{ row }">{{ row.rewardAmount }}元</template>
      </el-table-column>
      <el-table-column :formatter="ruleFormatter" label="事由" />
      <el-table-column label="状态">
        <template #default="{ row }">
          {{ WITHDRAWAL_STATUS_CN[row.status] }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" :width="160">
        <template #default="{ row }">
          <el-link type="primary" :underline="false" @click="detailModal.open(row)">查看详情</el-link>
          <el-link
            v-if="row.status === WITHDRAWAL_STATUS.AUDIT"
            type="primary"
            :underline="false"
            @click="auditModal.open(row)"
          >
            审批
          </el-link>
        </template>
      </el-table-column>
      <template #empty>
        <el-empty class="vab-data-empty" description="暂无数据" />
      </template>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      v-model:current-page="queryParams.pageNum"
      background
      layout="prev, pager, next"
      :page-size="queryParams.pageSize"
      :total="queryParams.total"
      @current-change="query"
    />

    <!-- 查看详情 -->
    <el-dialog
      destroy-on-close
      :model-value="detailModal.visible"
      title="查看详情"
      :width="980"
      @close="detailModal.close()"
    >
      <WithdrawalDetail :data="detailModal.data" />
      <template #footer>
        <el-button @click="detailModal.close()">关闭</el-button>
      </template>
    </el-dialog>

    <!-- 审批 -->
    <el-dialog
      destroy-on-close
      :model-value="auditModal.visible"
      title="查看详情"
      :width="480"
      @close="auditModal.close()"
    >
      <AuditForm ref="auditFormRef" :data="auditModal.data" @success="onSuccess" />
      <template #footer>
        <el-button @click="auditModal.close()">取消</el-button>
        <el-button type="primary" @click="auditFormRef.submit()">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
  import { ref, reactive, onMounted } from 'vue'
  import { getWithdrawalList } from '@/api/recruitment'
  import { omit, compact } from 'lodash'
  import { useModal } from '@/hooks/useModal'
  import WithdrawalDetail from './WithdrawalDetail.vue'
  import AuditForm from './AuditForm.vue'
  import { WITHDRAWAL_STATUS, WITHDRAWAL_STATUS_CN } from '../context'
  import { ruleFormatter } from '../helper'

  const statusOptions = Object.entries(
    omit(WITHDRAWAL_STATUS_CN, WITHDRAWAL_STATUS.PAID, WITHDRAWAL_STATUS.PAY_ERROR)
  ).map(([k, v]) => ({
    value: k,
    label: v,
  }))

  const defaultQueryParams = {
    phone: '',
    likeName: '',
    status: '',
    pageNum: 1,
    pageSize: 20,
    total: 0,
  }

  const queryParams = reactive({ ...defaultQueryParams })

  const loading = ref(false)
  const tableData = ref([])

  onMounted(() => {
    query()
  })

  function query(pageNum = queryParams.pageNum) {
    const params = {
      ...omit(queryParams, 'total'),
      pageNum,
    }

    loading.value = true

    getWithdrawalList(params)
      .then(({ code, data }) => {
        if (code !== 200) return
        const { list, total } = data
        list.forEach((e) => {
          e.userVos = compact(e.userVos)
          e.userNames = e.userVos.map((e) => e.name).join('、')
        })
        tableData.value = list
        queryParams.total = total
      })
      .finally(() => {
        loading.value = false
      })
  }

  function reset() {
    for (const k in defaultQueryParams) {
      queryParams[k] = defaultQueryParams[k]
    }
    query(1)
  }

  const auditModal = useModal()
  const detailModal = useModal()

  const auditFormRef = ref()

  function onSuccess() {
    auditModal.close()
    query()
  }
</script>

<style lang="scss" scoped>
  .withdrawal {
    padding: 16px;
  }
</style>
